<template>
    <v-dialog v-model="dialog" width="600">
        <v-card>
            <v-card-title class="headline">
                Dodaj użytkownika
            </v-card-title>
            <v-card-text>
                <v-form
                    ref="newForm"
                    v-model="valid"
                    lazy-validation
                    class="dimension--form mt-5 mb-5"
                >
                    <v-row>
                        <v-col cols="12" md="12" align-self="start" dense>
                            <v-text-field
                                v-model="form.email"
                                class="pt-0"
                                label="Email"
                                type="email"
                                placeholder=" "
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            @click.prevent="onSubmit"
                            type="Submit"
                            class="action-btn--green-gradient place-btn wastemaster-action-btn text-none"
                            large
                        >Dodaj&nbsp;<v-icon size="24">mdi-send</v-icon>
                        </v-btn
                        >
                    </v-card-actions>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>

import api from "@/services/api";
import transactionTypeMixin from "@/mixins/transactionTypeMixin";
import transportConditionMixin from "@/mixins/transportConditionMixin";
import categoryMixin from "@/mixins/categoryMixin";
import priceMixin from "@/mixins/priceMixin";
import paymentConditionMixin from "@/mixins/paymentConditionMixin";
import dateMixin from "@/mixins/dateMixin";
import validationHelpers from '@/mixins/validationHelpers'

export default {
    name: 'ModalAddCompanyUser',
    components: {},
    props: {
        item: {},
    },
    mixins: [
        transactionTypeMixin,
        transportConditionMixin,
        categoryMixin,
        priceMixin,
        paymentConditionMixin,
        dateMixin,
        validationHelpers
    ],
    created() {
    },
    data: () => ({
        props: {
            item: {},
        },
        dialog: false,
        form: {
            email: '',
        },
        formRules: {
            email: [(value) => value.length === 0 || 'Wpisz email'],
        },
        valid: false,
    }),
    methods: {
        open() {
            this.dialog = true
        },
        async onSubmit() {
            if (!this.$refs.newForm.validate()) {
                return
            }

            const user = {
                email: this.form.email,
                companyId: this.item,
            }

            api
                .post('/api/auth/register/company', user)
                .then(() => {
                    this.$root.$emit('notifySuccess', {
                        html: 'Użytkownik został dodany.',
                    });
                    this.dialog = false;
                    this.form.email = '';
                    this.$parent.getUsers();
                })
                .catch((error) => {
                    console.error('Error when adding a dimension:', error);

                    if (error.response.data.errors[0].code === '3a6c00dd-d00f-4eda-95d7-df85625c693b') {
                        this.$root.$emit('notifyWarning', {
                            html: 'Użytkownik z podanym adresem emial już istnieje.',
                        });
                    } else {
                        this.$root.$emit('notfiy', {
                            html: 'Wystąpił błąd.',
                        });
                    }
                })
        },
    },
}
</script>

<style scoped></style>
